module.exports = __webpack_public_path__ + "static/img/zaiceB.0752d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zaiceB.png
// module id = oifY
// module chunks = 2